<template>
  <div id="tests" class="header-padding bg-light-grey">
    <header class="page-header border-bottom ff ff-center horizontal-padding section-padding">
      <h1 style="margin-bottom: 0;">Tests</h1>
      <p><strong>Please note:</strong> The minimum charge per sample is ${{ $store.state.global.minimum_price.toFixed(2) }} ex GST.</p>
      <div id="sample-types">
        <ul class="header-tabs ff ff-nowrap ff-align-center">
          <li 
            v-for="sampleType in $store.state.sampleTypes" 
            class="header-tab ff" 
            :key="'st-' + sampleType.slug"
          >
            <router-link :to="'/tests/' + sampleType.slug" class="ff ff-center ff-ttb ff-sm-ltr">
              <icon :name="'icon-' + sampleType.icon" color="grey" size=16 />
              <span class="ff-mobile-hide">{{ sampleType.name }}</span>
              <span class="ff-desktop-hide">{{ sampleType.slug }}</span>
            </router-link>
          </li>
        </ul>
      </div>
  </header>
    
    <section role="content" id="tests-content" class="horizontal-padding section-padding max-width" :class="testClass">
      <transition 
        name="page-swipe"
        mode="out-in"
        v-on:before-leave="beforeLeave"
        v-on:after-enter="afterEnter"
      >
        <router-view v-bind:key="$route.params.categorySlug"></router-view>
      </transition>
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "tests",
  data() {
    return {
      
    }
  },
  computed: {
    testClass() {
      let testClass = '';
      
      if(this.$route.name === 'Test') {
        testClass = 'is-aside'
      }
      
      return testClass;
    },
    meta() {
      var meta = {
        title: "Tests",
        url: "https://www.csbplab.com.au/tests",
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    
  },
  mounted() {
    
  },
  methods: {
    beforeLeave(el) {
      // Attach previous router-view height to <section>
      var testsContent = document.getElementById("tests-content");
      testsContent.style.height = parseFloat(getComputedStyle(el).height) + (parseFloat(getComputedStyle(testsContent).paddingTop) * 2) + 'px';
    },
    afterEnter(el) {
      // Attach new router-view height to <section>
      var testsContent = document.getElementById("tests-content");
      testsContent.style.height = parseFloat(getComputedStyle(el).height) + (parseFloat(getComputedStyle(testsContent).paddingTop) * 2) + 'px';
      
      // Attach 'auto' height to <section> after transition is complete
      setTimeout(function(){
        testsContent.style.height = 'auto';
      }, 1000);
    }
  },
  watch:{
    
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>